import React, { useState, useEffect } from 'react';
import { deBounceDefaultWait } from '../helpers';

export default function useDebounce(value, delay = deBounceDefaultWait) {
    const [debouncedValue, setDebouncedValue] = useState(value);

    useEffect(() => {
        const handler = setTimeout(() => {
            setDebouncedValue(value);
        }, delay);

        return () => {
            clearTimeout(handler);
        };
    }, [value]);

    return debouncedValue;
}
